var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSelectReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 23"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 17",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 12",
    d: "M728.581 2.665h-10.132a4.963 4.963 0 0 0-4.958 4.958v14.406a.992.992 0 0 0 1.544.824l3.856-2.583h9.691a4.963 4.963 0 0 0 4.958-4.958V7.623a4.963 4.963 0 0 0-4.958-4.958m2.975 12.647a2.978 2.978 0 0 1-2.975 2.975h-9.992a.992.992 0 0 0-.552.168l-2.563 1.717V7.623a2.978 2.978 0 0 1 2.974-2.975h10.132a2.978 2.978 0 0 1 2.975 2.975z",
    transform: "translate(-712.514 -1.842)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13",
    d: "m736.361 17.624-1.7-.247a.518.518 0 0 1-.389-.283l-.761-1.543a.517.517 0 0 0-.928 0l-.761 1.543a.518.518 0 0 1-.389.283l-1.7.247a.517.517 0 0 0-.287.882l1.232 1.2a.518.518 0 0 1 .149.458l-.291 1.7a.517.517 0 0 0 .75.545l1.523-.8a.518.518 0 0 1 .481 0l1.523.8a.517.517 0 0 0 .75-.545l-.291-1.7a.518.518 0 0 1 .149-.458l1.232-1.2a.517.517 0 0 0-.287-.882",
    transform: "translate(-722.043 -9.443)",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectReview);
export default __webpack_public_path__ + "static/media/ic-select-review.86e068a6efed7bd6c6b1902ea5dea6f8.svg";
export { ForwardRef as ReactComponent };